{
  "screen": {
    "overline": "OUR GUIDES",
    "title": "Meet Your",
    "titleHighlight": "Masters",
    "subtitle": "Experienced practitioners dedicated to guiding you on your journey of growth and self-discovery.",
    "searchPlaceholder": "Search by name or practice...",
    "loading": "Syncing experts...",
    "retryConnection": "RETRY CONNECTION",
    "noResults": "No Results Found",
    "comingSoon": "Coming Soon",
    "noResultsHint": "Try searching with a different keyword.",
    "comingSoonHint": "We are currently onboarding new masters.",
    "viewJourney": "VIEW JOURNEY"
  },
  "specialties": {
    "all": "All",
    "yogaMovement": "Yoga & Movement",
    "meditation": "Meditation",
    "buddhism": "Buddhism",
    "shaivism": "Shaivism",
    "psychology": "Psychology",
    "wellness": "Wellness",
    "breathwork": "Breathwork"
  },
  "detail": {
    "allMasters": "ALL MASTERS",
    "masterProfile": "MASTER PROFILE",
    "defaultTagline": "Yoga & Meditation · Breathwork · Mindfulness",
    "overview": "Overview",
    "content": "Content",
    "community": "Community",
    "events": "Events",
    "all": "All",
    "upcomingLives": "Upcoming Live Sessions",
    "pastLives": "Past Live Sessions",
    "videoPractices": "Video Practices",
    "noContentAll": "No content available at the moment.",
    "noContentUpcoming": "No upcoming live sessions scheduled.",
    "noContentPast": "No past recordings available.",
    "noContentVideos": "No video practices published yet.",
    "recording": "RECORDING",
    "video": "VIDEO",
    "practice": "Practice",
    "messageMaster": "Message Master",
    "messageIntro": "Hi! I'd like to know more about {{title}}...",
    "about": "About",
    "masterBio": "Master Bio",
    "manifesto": "Manifesto",
    "upcomingSessions": "Upcoming Sessions",
    "liveStreamsByMaster": "Live sessions and events by {{name}}",
    "noUpcomingSessions": "No upcoming sessions at the moment.",
    "viewAllSessions": "VIEW ALL SESSIONS",
    "couldntLoadContent": "Couldn't load content.",
    "upcomingEvents": "Upcoming Events",
    "retreatsAndGatherings": "Retreats, workshops, and gatherings by {{name}}",
    "noUpcomingEvents": "No upcoming events at the moment.",
    "getNotified": "Get notified about {{name}}'s upcoming sessions",
    "defaultBio": "A dedicated practitioner sharing the path of inner growth and mindful living.",
    "masterNotFound": "Master not found",
    "welcomeTo": "Welcome to  {{name}}",
    "followers": "Followers",
    "videos": "Videos",
    "lives": "Live sessions",
    "pushOn": "Notifications on",
    "pushOff": "Notifications off",
    "addToCal": "Add to Cal",
    "aboutThisEvent": "ABOUT THIS EVENT",
    "contact": "CONTACT",
    "filled": "filled",
    "register": "REGISTER",
    "message": "MESSAGE",
    "messageSent": "Message sent",
    "messageDelivered": "Your message has been delivered to {{name}}. They will respond shortly.",
    "yourName": "YOUR NAME *",
    "enterYourName": "Enter your name",
    "yourEmail": "YOUR EMAIL",
    "emailPlaceholder": "your@email.com",
    "messageFieldLabel": "MESSAGE *",
    "sendMessage": "SEND MESSAGE",
    "orEmailDirectly": "Or email directly:",
    "fillNameAndMessage": "Please fill in your name and message",
    "spotsLeft": "{{left}} / {{total}} spots left",
    "unlimitedSpots": "Unlimited spots",
    "follow": "FOLLOW",
    "following": "FOLLOWING",
    "subscribe": "SUBSCRIBE",
    "retry": "RETRY",
    "online": "ONLINE",
    "offline": "OFFLINE",
    "live": "LIVE",
    "about_": "About:",
    "questionAbout": "Question about: {{title}}"
  },
  "eventTypes": {
    "retreat": "RETREAT",
    "workshop": "WORKSHOP",
    "ceremony": "CEREMONY",
    "class": "CLASS",
    "festival": "FESTIVAL"
  },
  "calendar": {
    "mon": "MON",
    "tue": "TUE",
    "wed": "WED",
    "thu": "THU",
    "fri": "FRI",
    "sat": "SAT",
    "sun": "SUN",
    "todaysSchedule": "Today's Schedule",
    "noEventsThisDay": "No events this day"
  },
  "categories": {
    "mindfulness": "Mindfulness",
    "yoga": "Yoga",
    "breathwork": "Breathwork",
    "meditation": "Meditation"
  },
  "native": {
    "title": "Masters",
    "subtitle": "Find masters and people\nwho resonate with your path.",
    "empty": "No one found",
    "searchA11y": "Search",
    "filtersA11y": "Filters",
    "mySubscriptions": "My subscriptions",
    "all": "All",
    "followersCount_one": "{{count}} follower",
    "followersCount_other": "{{count}} followers"
  }
}
